var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 90h22c1.11 0 2 0.9 2 2v22c0 1.11-0.89 2-2 2H2c-1.1 0-2-0.89-2-2V92C0 90.9 0.9 90 2 90z","fill":"#C62828","key":0}),React.createElement("path",{"d":"M18.46 101.33h-0.91v5.09l-8.37-8.37L8.52 98.7l8.44 8.44h-5.22v0.91h6.72V101.33z","style":{"fill":"#FFF","strokeWidth":"2","stroke":"#FFF"},"key":1})]);
}

Down.defaultProps = {"width":"37.11","height":"26.64","viewBox":"-0.31 89.69 37.11 26.64"};

module.exports = Down;

Down.default = Down;
